module.exports = __webpack_public_path__ + "static/media/logo.2c14b5f0.svg";